// extracted by mini-css-extract-plugin
export default {"inputStyle":"styles_inputStyle__Vu9s6"};